import './src/css/global.css'
import React from 'react';
import { siteInit } from "./src/utils/siteInit";
import { detectAndRedirectLanguage } from "./src/utils/languageDetection";
import CookieConsent from './src/components/shared/CookieConsent';

export const onClientEntry = async () => {
    if (detectAndRedirectLanguage()) return;
    await siteInit();
};

export const onRouteUpdate = ({ location, prevLocation }) => {
    if (!prevLocation || location.pathname !== prevLocation.pathname) {
        if (!location.hash) {
            setTimeout(() => window.scrollTo(0, 0), 0);
        }
    }
};

export const wrapPageElement = ({ element }) => (
    <>
        {element}
        <CookieConsent />
    </>
);
